import React from 'react'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { selectTermById } from '../../services/node/index'
import Link from '../Link/index'
import { H2, HEADING_TYPES } from '../Heading/index'
import { getTopicGA4Data } from './utils'

/**
 * The topics card title component
 * @param {Object} props - The props
 * @param {String} props.label - The label
 * @param {String} props.language - The user's language
 * @param {Map} props.parentTermData - The parentTermData data
 * @returns {JSX.Element|null} Card title component
 */
const TopicsPageV3CardTitle = (props) => {
  const { parentTermData, label } = props
  const path = parentTermData.get('path')
  const tid = parentTermData.get('nid')
  const ga4TrackingData = getTopicGA4Data({ name: label, tid })

  if (!path) {
    return (
      <H2 as={HEADING_TYPES.H6} className="topics-v3__card-title">{label}</H2>
    )
  }

  return (
    <H2 as={HEADING_TYPES.H6} className="topics-v3__card-title">
      <Link
        to={path}
        className="topics-v3__card-title-link"
        ga4EventData={ga4TrackingData}
      >
        {label}
      </Link>
    </H2>
  )
}

export default compose(
  connectRedux(
    (state, props) => {
      const { parentTermId, language } = props
      const parentTermData = selectTermById(state, { id: parentTermId, language, subPath: ['data'] })

      return { parentTermData }
    },
  ),
)(TopicsPageV3CardTitle)
